module.exports = __webpack_public_path__ + "static/media/ati-logo.16bf676b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/ati-logo.png
// module id = 970
// module chunks = 0